import { ChangeEvent } from 'react'
import { UseFormSetValue } from 'react-hook-form'

export const handleDataChange = (
  e: ChangeEvent<HTMLInputElement>,
  setValue: UseFormSetValue<any>,
  fieldName: string
): void => {
  const { value } = e.target
  let formattedValue = value.replace(/[^0-9]/g, '').substring(0, 8)

  if (formattedValue.length > 4) {
    formattedValue = formattedValue.replace(/(\d{2})(\d{2})(\d+)/, '$1/$2/$3')
  } else if (formattedValue.length > 2) {
    formattedValue = formattedValue.replace(/(\d{2})(\d+)/, '$1/$2')
  }

  setValue(fieldName, formattedValue, { shouldValidate: true })
}
